import(/* webpackMode: "eager" */ "/home/hyrelancer_frontend/hyrelancer/src/app/(auth)/login/page.jsx");
